module.exports = __webpack_public_path__ + "img/symbol_9.c0fc5c51.png";